import { cn } from "@/lib/utils"

/**
 * Skeleton is a visual-only placeholder. Its parent region MUST carry
 * aria-busy="true" while loading is in progress, and SHOULD carry
 * role="status" so screen readers announce the loading state.
 *
 * Example:
 *   <div aria-busy={isLoading} role="status" aria-label="Loading dashboards">
 *     {isLoading ? <Skeleton className="h-40 rounded-lg" /> : <DashboardsGrid />}
 *   </div>
 *
 * Per brand-guide §15.
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
